export default "__VITE_ASSET__ca55b707__"